import Urls from '../config/Urls';

export default function getSignupUrl(returnUrl: string) {

  return `${Urls.Login}/signup?returnUrl=${encodeURI(returnUrl)}`
}
